const NUMERO_BR = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Valor em reais para mostrar na tela, sem o "R$": 14.9 → "14,90", 1200 → "1.200,00".
 * Não usar no payload do Pix (BR Code exige ponto) nem em campos de digitação.
 */
export function formatBRLNumber(value: number | null | undefined): string {
  const n = Number(value);
  return NUMERO_BR.format(Number.isFinite(n) ? n : 0);
}
